// extracted by mini-css-extract-plugin
export default {"shield":"DoubleClickShield_shield__3y53w"};